import angular from 'angular'

export default ['$element', 'uiStateManagerService', uiStateChangerController]

let currentState = 0
function uiStateChangerController($element, uiStateManagerService) {
  this.toggleNextState = function toggleNextState() {
    currentState = currentState += 1
    if (currentState > this.toggleStates.length - 1) {
      this.currentState = 0
    }
  }
  this.obtainCurrentState = function obtainCurrentState() {
    return this.toggleStates[currentState]
  }
  this.activate = function uiStateChangerControllerActivate() {
    if (this.toggleBetweenStates) {
      this.toggleState()
    }
    uiStateManagerService.triggerStateChange(this.stateName, {
      sender: this.sender,
      action: this.action,
      state: this.obtainCurrentState(),
      priority: this.priority,
      payload: this.payload,
      stateName: this.stateName,
    })
  }
  this.$onInit = function uiStateChangerControllerInit() {
    if (this.stateName === undefined) {
      throw new Error('Unable to find stateName')
    }
    // Step through the states
    this.toggleBetweenStates = this.toggleBetweenStates || false
    // active and disabled are pretty much the only states you'd care about, but you can add more if you'd like
    this.toggleStates = this.toggleStates || ['active', 'disabled']
    // Additional object to be added to the event
    this.payload = this.payload || {}
    // How important is this event
    this.priority = parseInt(this.priority || '100')
    // Sometimes we'll be listening to a $rootScope.$event. Pass that in here.
    this.sender = this.sender || {}
    // Simular to Sender, but a forward vector.
    this.action = this.action || {}
    // Allow the parent controller to disable inputs. ( Seems redundent )
    this.disableInputs = this.disableInputs || false
    this.i18nAssist = this.i18nAssist || null
  }
  this.$postLink = function uiStateChangerControllerPostLink() {
    /*
     * Not sure why, but this is an inconsistent API with angular.
     *  $element.attr('name', 'key') to add
     *  $erement.removeAttr('name') to remove
     *
     * Any thoughts?
     */
    if (angular.isDefined(this.i18nAssist) && this.i18nAssist !== null) {
      $element.find('a[ng-transclude]').attr('title', this.i18nAssist)
      $element.find('a[ng-transclude]').attr('alt', this.i18nAssist)
    }
  }
}
